import React, {Component} from "react"
import axios from "axios"
import {clearAccessTokenAndRedirectToLogin, getHeader, verifyCodeUrl} from "../../config";
import ActivateForm from "../../components/ActivateForm";
import {Redirect, withRouter} from "react-router-dom";
import {showToast} from "../../helpers/magic";
import {profile} from "../../store/actions/userActions";
import {changeActivationPopUpStatus} from "../../store/actions/reservationActions";
import {connect} from "react-redux";
import {withTranslate} from "react-redux-multilingual";

class Activate extends Component {
    state = {
        pin: null,
        errorMsg: false,
        loading: false,
        errorMsgText : null,
        fromOtherLink: false
    };
    componentDidMount() {
        this.setState({
            fromOtherLink: false
        });
        if (this.props.match.path.includes("doctor")) {
            this.setState({
                fromOtherLink: true
            })
        }
    };
    activateAccount = (e) => {
        e.preventDefault();
        // start loading
        this.setState({
            loading: true,
        });
        axios.post(verifyCodeUrl, this.state, {headers: getHeader()}).then(res => {
            // start loading
            this.setState({
                loading: false,
            });
            if (res.data.Error.code === 20) {
                localStorage.setItem("isActive", "1");
                localStorage.removeItem("code");
                if (!this.props.match.path.includes("doctor")) {
                    window.location.href = "/profile"
                }else {
                    this.props.changeActivationPopUpStatus(false);
                    showToast(this.props.translate('activated_successfully'), "green")
                }
            } else {
                this.setState({
                    errorMsgText: res.data.Error.desc,
                    errorMsg: true,
                    loading: false,
                })
            }
        }).catch(error => {
            this.setState({
                loading: true,
            });
            console.log(error);
            clearAccessTokenAndRedirectToLogin(error)
        })
    };

    handleInputChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        });
    };

    render() {
        return (
            <div id="activation">
                <ActivateForm onSubmission={this.activateAccount}
                              sendCodeErrorMsg={this.props.sendCodeErrorMsg}
                              fromOtherLink={this.state.fromOtherLink}
                              changeActivationFormStatus={(e, status) => this.props.changeActivationFormStatus(e, status)}
                              errorMsg={this.state.errorMsg}
                              errorMsgText={this.state.errorMsgText}
                              handleInputChange={this.handleInputChange}
                              loading={this.state.loading}/>
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        // for show/hide activation pop up
        activationPopUpStatus: state.reservation.activationPopUpStatus,
    }

};

const mapDispatchToProps = (dispatch) => {
    return {
        // for show/hide activation pop up
        changeActivationPopUpStatus: (status) => dispatch(changeActivationPopUpStatus(status)),
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withTranslate(Activate)))
